<template>
  <div class="headernav">
    <div class="float-right logo-wrapper" >
      <img src="../../assets/images/rubylogonew.png" class="img-fluid" alt />
    </div>
  </div>
</template>

<script>
export default {
  name: "Headernav",
  components: {}
};
</script>

<style></style>
